import { BaSeDialogContext } from '@base/react';
import React from 'react';
import { useAnswerService } from '../services/answer-service';

export const useAnswerController = () => {
  const {
    findAnswersByInterview,
    creteNewAnswer,
    update,
    sendAnswer,
    prepareAnswersForInterview,
    resendAnswer,
    putValidateAnswersFilter,
    resendAnswerMutiple,
    findAnswersByInterviewStartup,
    putAvaliarEntrevista,
  } = useAnswerService();
  const [loading, setLoading] = React.useState(false);

  const { showNotification } = React.useContext(BaSeDialogContext);

  const getAnswersByInterview = React.useCallback(
    (idInterview) => {
      setLoading(true);
      return findAnswersByInterview(idInterview)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [findAnswersByInterview],
  );

  const getAnswersByInterviewStartup = React.useCallback(
    (idInterview) => {
      setLoading(true);
      return findAnswersByInterviewStartup(idInterview)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [findAnswersByInterviewStartup],
  );

  const prepareAnswers = React.useCallback(
    (interviewId) => {
      setLoading(true);
      return prepareAnswersForInterview(interviewId)
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [prepareAnswersForInterview],
  );

  const createAnswer = React.useCallback(
    (answer) => {
      setLoading(true);
      return creteNewAnswer(answer)
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [creteNewAnswer],
  );

  const validateAnswersFilter = React.useCallback(
    (idAnswer) => {
      setLoading(true);
      return putValidateAnswersFilter(idAnswer)
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [putValidateAnswersFilter],
  );

  const avaliarEntrevista = React.useCallback(
    (id, option) => {
      setLoading(true);
      return putAvaliarEntrevista(id, option)
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [putAvaliarEntrevista],
  );

  const updateAnswer = React.useCallback(
    (answer, setSalved) => {
      setLoading(true);
      return update(answer)
        .then((data) => {
          setLoading(false);
          setSalved && setSalved(true);
          return data;
        })
        .catch((error) => {
          showNotification({
            message: 'Falha na conexão, tentando reconectar.',
            supportMessage:
              'Aconselhamos que salve suas respostas em outro local.',
            color: 'destructive',
          });

          throw error;
        })
        .finally(() => setLoading(false));
    },
    [showNotification, update],
  );

  const sendAnswerInterview = React.useCallback(
    (sendAnswerInterview, idModule) => {
      setLoading(true);
      return sendAnswer(sendAnswerInterview, idModule)
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [sendAnswer],
  );

  const resendAnswerInterview = React.useCallback(
    (idInterview) => {
      setLoading(true);
      return resendAnswer(idInterview)
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [resendAnswer],
  );

  const resendAnswerInterviewmutiple = React.useCallback(
    (idsInterview) => {
      setLoading(true);
      return resendAnswerMutiple(idsInterview)
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [resendAnswerMutiple],
  );

  return {
    getAnswersByInterview,
    createAnswer,
    updateAnswer,
    sendAnswerInterview,
    prepareAnswers,
    resendAnswerInterview,
    loading,
    validateAnswersFilter,
    resendAnswerInterviewmutiple,
    getAnswersByInterviewStartup,
    avaliarEntrevista,
  };
};
